import type { FaireProductEntity } from "../../entity_types/product";

export const p_hmub4waxm2: FaireProductEntity = {
  token: "p_hmub4waxm2",
  type: "product",
  name: "Women's AirThermal Waffle Knit V-Neck Long Sleeve & Pant Set",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/426eb3cc146d171bedfd217515b20c3db68f67cc708638ca0379d3598aec93a3.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/255761850a5d33e42730a8d31681dc62760b0093e174bcaf5c9341f05010ae26.jpeg",
    "https://cdn.faire.com/fastly/dd597439389e0abb3afced77a3da582f3411ff58a70efd001e0b7d76ce5ce853.jpeg",
    "https://cdn.faire.com/fastly/82e4ba83b32f963af67d7e5b96eb7345f52afa91cc0cd475041d71eab8b661d1.jpeg",
    "https://cdn.faire.com/fastly/b7a618dc7f1379a382ad89af87c3ffc69fc09882e21c0a3c5f22766ee905e4c2.jpeg",
    "https://cdn.faire.com/fastly/c1c5b023153714117ba597c2bd9ccfc55920817d002f7697eb04a1c8b9bf24a6.jpeg",
    "https://cdn.faire.com/fastly/e4da903d568838fc8ead005776a0584fcc9986660e67fbbfed15af7b915d741f.jpeg"
  ],
  priceDollars: 75,
  description: "Lightweight warmth. Refined ease. Designed for comfort that moves with you. \n\nFabrication:\n● AirThermal fabric offers lightweight warmth without bulk\n● Breathable waffle-knit texture enhances comfort and airflow\n● Ultra-soft handfeel creates a relaxed, lived-in feel from the first wear\n\nFeatures:\n● Flattering V-neck silhouette for an easy, versatile look\n● Long-sleeve top paired with coordinating full-length pants\n●  Relaxed fit designed for lounging, layering, and everyday comfort\n● 28\" Inseam Pant with Drawstring Waist\n\nMaterials & Care:\n● Easy care, colorfast, and machine washable\n● 44% Rayon, 28% Polyester, 24% Nylon, 4% Spandex\n● Retains its softness and shape wash after wash\n\nBest For:\n● Travel days\n● Resort lounging\n● Transitional weather",
  tags: [],
  msrpDollars: 150,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:05.843Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
